import { BaseTracking } from "app/core/tracking/base-tracking";
import { Logger } from "../../helpers/Logger";
import { HttpService } from "../../services/http.service";
import { UtilityScripts } from "../../helpers/utility-scripts";
import { AppServices } from "app/app.services";
import { LaunchDataVO } from "./xapi/launchdatavo";
import { Subscription } from "rxjs";
import { LaunchURLVO } from "./xapi/launchurlvo";
import { API } from "./xapi/api.service";
import { ApplicationModel } from "../models/application.model";
import { QuestionDataVO } from "app/rubrics/adaptive/vo/questiondatavo";
import { Statements } from "./xapi/statements";
import { StatementDataVO } from "app/rubrics/adaptive/vo/statementDataVO";

export class CMI5 extends BaseTracking {
	private httpService: any;
	private appService: AppServices;
	private configVO: any;
	private launchDataVO: LaunchDataVO;
	private courseCompletedSubscription: Subscription;
	private launchURLVO: LaunchURLVO;
	private token: string;
	private api: API;
	private hasRedirected: Boolean = false;
	private statements: Statements;

	public init(
		configVO: any,
		_httpService: HttpService = null,
		appService: AppServices = null
	) {
		super.init(configVO);
		this.httpService = _httpService;
		this.appService = appService;
		this.configVO = configVO;
		this.courseCompletedSubscription =
			this.appService.courseCompleted$.subscribe((event) =>
				this.courseCompletedHandler()
			);
	}
	public async doInitialize() {
		let launch_URL = document.location.search;
		this.launchURLVO = this.setLaunchURLVO(launch_URL);
		console.log("launch_URL   ", launch_URL);
		console.log("this.launchURLVO   ", this.launchURLVO);
		if (this.launchURLVO.fetch) {
			await this.getTokenFromFetchURL();
			this.handleInitialized();
		} else {
			this.token = this.launchURLVO.auth;
		}
	}
	//
	private async handleInitialized() {
		this.api = new API(
			this.httpService,
			this.launchURLVO,
			"Basic " + this.token
		);
		await this.setTrackingData();
		this.notifyInitialize();
		this.appService.trackingManagerInitilaized();
	}

	private async setTrackingData() {
		let updatedActor = JSON.parse(this.launchURLVO.actor);
		updatedActor.name = updatedActor.account.name;
		let res_launchData = await this.api.getLaunchData(this.getQueryString());
		let res_preferences = await this.api.getAgentProfile(
			encodeURIComponent(JSON.stringify(updatedActor))
		);
		let res_bookmark_data = await this.api.getState(
			"bookmark_data",
			this.getQueryString()
		);
		let res_suspenddata
		let res_location
		let res_lessonStatus
		let res_adaptive_reporting
		if(!res_bookmark_data){
			/* This is a backup compatibilty code that needs to be deleted after certain time */
			res_location = await this.api.getState(
				"lesson_location",
				this.getQueryString()
			);
			res_suspenddata = await this.api.getState(
				"suspend_data",
				this.getQueryString()
			);
			res_lessonStatus = await this.api.getState(
				"lesson_status",
				this.getQueryString()
			);
			res_adaptive_reporting = await this.api.getState(
				"adaptive_reporting",
				this.getQueryString()
			);
			if(res_suspenddata){
				res_suspenddata = JSON.parse(res_suspenddata.body).suspend_data;
			}
			if(res_location){
				res_location = JSON.parse(res_location.body).lesson_location;
			}
			if(res_lessonStatus){
				res_lessonStatus = JSON.parse(res_lessonStatus.body).lesson_status;
			}
			if(res_adaptive_reporting){
				res_adaptive_reporting = JSON.parse(res_adaptive_reporting.body).adaptive_reporting;
			}
			/* ------------------------------------------------------------------------ */
		} else {
			res_suspenddata = JSON.parse(res_bookmark_data.body).suspend_data;
			res_location = JSON.parse(res_bookmark_data.body).lesson_location;
			res_lessonStatus = JSON.parse(res_bookmark_data.body).lesson_status;
			res_adaptive_reporting = JSON.parse(res_bookmark_data.body).adaptive_reporting;
		}

		let res_statements = await this.api.getStatements();
		/* The below code handles the corrupt bookmark value */
		if(this.isBookmarkCorrupted(res_suspenddata)){
			alert("An error has occurred in capturing any previous progress and your course has been restarted. If you have any concerns, please contact your administrator. For reference, the saved bookmark is:\n\n"+res_suspenddata.body);
			res_suspenddata = null;
			res_location = null;
			res_lessonStatus = null;
			res_adaptive_reporting = null;
		}
		this.setLaunchData(JSON.parse(res_launchData.body));
		let launchParameters = JSON.parse(
			JSON.stringify(eval("(" + this.launchDataVO.launchParameters + ")"))
		);
		let isAdaptive = false;
		if(!res_adaptive_reporting){
			await this.httpService.getXmlData(launchParameters.configdoc).then((res: any) => {
				if(res.getElementsByTagName("playerType")[0]){
					isAdaptive = true;
				}
			});
		}
		if(!res_location || !res_suspenddata || (!res_adaptive_reporting && isAdaptive)){
			if(!(!res_location && !res_suspenddata && !res_adaptive_reporting && !res_lessonStatus)){
				alert("An error has occurred in capturing any previous progress and your course has been restarted. If you have any concerns, please contact your administrator.")
				res_location = null;
				res_suspenddata = null;
				res_adaptive_reporting = null;
				res_lessonStatus = null;
				this.trackingVO.lessonStatus = "i";
			}
		} 
		if(!res_lessonStatus){
			res_lessonStatus = null;
			this.trackingVO.lessonStatus = "i";
		}

		/* ------------------ end -------------------------- */

		if (res_adaptive_reporting) {
			this.trackingVO.attempts = res_adaptive_reporting.attempts;

			let failureValue = res_adaptive_reporting.failure;
			
			this.trackingVO.failure = [];
			if (typeof failureValue === 'string') {
				this.trackingVO.failure.push(failureValue);
			}else{
				this.trackingVO.failure = failureValue;
			}

			this.trackingVO.moduleScore = res_adaptive_reporting.moduleScore;
			this.trackingVO.maxModuleScore = res_adaptive_reporting.maxModuleScore;
		}
		let statements;
		console.log("res_launchData ", JSON.parse(res_launchData.body));
		
		this.configVO.opProfile =
			this.launchDataVO.launchMode.toLowerCase() == "normal" ? "run" : "demo";
		ApplicationModel.instance.mode = this.configVO.opProfile;
		this.getLaunchURLVO().configDoc = launchParameters.configdoc;
		this.getLaunchURLVO().branding_profile = launchParameters.branding_profile
			? launchParameters.branding_profile
			: "";

		if (res_location) {
			this.trackingVO.lessonLocation = res_location;
		} 
		if (res_suspenddata) {
			this.parseSuspenddata(res_suspenddata);
		}
		if (res_lessonStatus) {
			this.trackingVO.lessonStatus = res_lessonStatus;
		} else {
			this.trackingVO.lessonStatus = "i";
		}
		this.trackingVO.studentName = JSON.parse(this.getLaunchURLVO().actor)[
			"name"
		]
			? JSON.parse(this.getLaunchURLVO().actor)["name"]
			: JSON.parse(this.getLaunchURLVO().actor)["account"]["name"];
		this.statements = new Statements(
			this.trackingVO,
			this.launchDataVO,
			this.launchURLVO
		);

		this.api.sendStatements(
			this.createStatements(this.getStatementDataVO("initialized"))
		);
	}

	/**Function to get StatementDataVO for cmi5 defined statements
	 * Setting all the attributes are not needed here for cmi5 defined statements.
	 * Only verb and statementType is required.
	 */
	private getStatementDataVO(verb): StatementDataVO {
		let statementDataVO = new StatementDataVO(verb);
		statementDataVO.statementType = "defined";
		return statementDataVO;
	}

	private parseSuspenddata(rawData: string) {
		rawData = UtilityScripts.dataEscapeUnescape(
			rawData,
			"unescape",
			this.escapeCount
		);
		let lines: Array<string> = rawData.split("&");
		for (let l in lines) {
			if (lines[l].indexOf(">") > 0) {
				let assigns: Array<string> = lines[l].split(">");
				//Logger.log(l,lines[l],assigns,Number(assigns[1]),parseInt(assigns[1]))
				if (assigns[0] === "score") {
					this.trackingVO.score = parseInt(assigns[1]);
				} else if (assigns[0] === "geolocation") {
					this.trackingVO.geoLocation = assigns[1];
				} else {
					this.trackingVO[assigns[0]] = assigns[1];
				}
				//Logger.log( 4, 'this.trackingVO.' , assigns[ 0 ] , ' = ' , assigns[ 1 ] );
			}
		}
		/* ------- Below code is added to handle the error in case the 'elt_total_time' is not in correct format (i.e. 0000:00:00.00) --------------*/
		if (
			rawData != "" &&
			rawData != "undefined" &&
			rawData != undefined &&
			rawData != null
		) {
			this.trackingVO["elt_total_time"] = UtilityScripts.resolveTime(
				this.trackingVO["elt_total_time"].split(".")[0]
			);
		}
		/* ----------------------------------------------------------------------------------------------------------------*/
	}

	private async courseCompletedHandler() {
		await this.api.sendStatements(
			this.createStatements(this.getStatementDataVO("passed"))
		);
		await this.api.sendStatements(
			this.createStatements(this.getStatementDataVO("completed"))
		);
		this._notifier.next('completed');
	}

	public doCommit() {
		this.saveData();
		return true;
	}

	private async saveData() {
		if (this.strOrigStatus === this.completedVal) {
			this.trackingVO.lessonStatus = this.completedVal;
		}
		let adaptive_reporting: any = {};
		adaptive_reporting.attempts = this.trackingVO.attempts;
		adaptive_reporting.failure = this.trackingVO.failure;
		adaptive_reporting.moduleScore = this.trackingVO.moduleScore;
		adaptive_reporting.maxModuleScore = this.trackingVO.maxModuleScore;
		let suspend_data: string = this.formSuspendData();
		let bookmark_data = await this.api.sendState(
			"bookmark_data",
			{ lesson_location: this.trackingVO.lessonLocation,
			  suspend_data: suspend_data,
			  lesson_status: this.trackingVO.lessonStatus,
			  adaptive_reporting: adaptive_reporting},
			this.getQueryString()
		);
	}

	public async doFinish() {
		await this.saveAndExit();
		return true;
	}

	public async saveAndExit() {
		await this.saveData();
		await this.exitCourse();
	}

	public async exitCourse() {
    // Commenting this code as Player unload is already handled independent of the way its closed.
		// await this.api.sendStatements(
		// 	this.createStatements(this.getStatementDataVO("terminated"))
		// );
		this.api.isTerminated = true;
		if (!this.hasRedirected && this.launchDataVO.returnURL) {
			this.hasRedirected = true;
			window.location.href = this.launchDataVO.returnURL;
		}

		return true;
	}

	public sendTerminateStatement() {
		let data = this.createStatements(this.getStatementDataVO("terminated"));
		this.api.sendTerminatedStatements(data);

	}

	private formSuspendData() {
		let suspend_data: string = "bookmark>" + this.trackingVO["bookmark"] + "&";
		suspend_data +=
			"completion_date>" + this.trackingVO["completionDate"] + "&";
		suspend_data +=
			"elt_total_time>" +
			UtilityScripts.resolveTime(this.trackingVO["totalTime"]); // + '&otherstuff>' + otherstuff
		// Save other suspend_data fields
		if (this.trackingVO.geoLocation != null) {
			suspend_data += "&geolocation>" + this.trackingVO.geoLocation;
		}
		if (this.trackingVO.score > 0) {
			suspend_data += "&score>" + this.trackingVO.score;
		}
		if(this.trackingVO.rubricStatus) {
			suspend_data += '&rubricStatus>' + this.trackingVO.rubricStatus;
		}
		suspend_data = UtilityScripts.dataEscapeUnescape(
			suspend_data,
			"escape",
			this.escapeCount
		); // this code line was commented in earlier version
		Logger.log(
			4,
			"suspend_data =============================================================" +
				suspend_data
		);
		console.log("formSuspendData = " + suspend_data);
		return suspend_data;
	}

	private setLaunchData(launchData) {
		this.launchDataVO = new LaunchDataVO();
		this.launchDataVO.objectType =
			launchData.contextTemplate.contextActivities.grouping[0].objectType;
		this.launchDataVO.id =
			launchData.contextTemplate.contextActivities.grouping[0].id;
		if (launchData.contextTemplate.contextActivities.grouping[0].definition)
			this.launchDataVO.name =
				launchData.contextTemplate.contextActivities.grouping[0].definition.name;
		else this.launchDataVO.name = "";
		this.launchDataVO.grouping =
			launchData.contextTemplate.contextActivities.grouping[0];
		this.launchDataVO.contextActivities =
			launchData.contextTemplate.contextActivities;
		this.launchDataVO.sessionid = launchData.contextTemplate.extensions;
		this.launchDataVO.launchMode = launchData.launchMode;
		this.launchDataVO.returnURL = launchData.returnURL;
		this.launchDataVO.launchMethod = launchData.launchMethod;
		this.launchDataVO.masteryScore = launchData.masteryScore ? launchData.masteryScore : 0;
		this.launchDataVO.moveOn = launchData.moveOn;
		this.launchDataVO.launchParameters = launchData.launchParameters;
		this.launchDataVO.clientKey = this.trackingVO.clientKey = launchData.clientKey;

		console.log("launch data ", launchData);
		console.log("this.launchDataVO ", this.launchDataVO);
	}

	/**
	 * Function to create generic Xapi statements.
	 */
	public createStatements(
		statementDataVO: StatementDataVO,
		questionDataVO?: QuestionDataVO
	) {
		return this.statements.createStatements(statementDataVO, questionDataVO);
	}

	// Get Token from fetchURL
	private async getTokenFromFetchURL() {
		const url: any = this.launchURLVO.fetch;
		let response: any;
		try {
			response = await this.httpService.post(url);
			this.token = JSON.parse(JSON.stringify(response))["auth-token"];
			console.log("this.token  : ", this.token);
		} catch (error) {
			console.log("error :", error);
		}
		return response;
	}

	private getQueryString() {
		let updatedActor = JSON.parse(this.launchURLVO.actor);
		updatedActor.name = updatedActor.account.name;
		const query =
			"agent=" +
			encodeURIComponent(JSON.stringify(updatedActor)) +
			"&activityId=" +
			encodeURIComponent(this.launchURLVO.activityId) +
			"&registration=" +
			encodeURIComponent(this.launchURLVO.registration);

		return query;
	}

	private setLaunchURLVO(strUrl: any): LaunchURLVO {
		const launchVO: LaunchURLVO = new LaunchURLVO();
		const arrUrlvariables = strUrl.substr(1).split("&");

		for (let item of arrUrlvariables) {
			const item_split = item.split("=", 2);
			if (item_split.length != 2) continue;
			//if (launchVO.hasOwnProperty(item_split[0])) {
			launchVO[item_split[0]] = decodeURIComponent(
				item_split[1].replace(/\+/g, " ")
			);
			console.log("VO: ", item_split[1].replace(/\+/g, " "));
			//}
		}
		launchVO.endpoint = UtilityScripts.stripTrailingSlash(launchVO.endpoint);
		return launchVO;
	}

	public getLaunchURLVO() {
		return this.launchURLVO;
	}

	public get API() {
		return this.api;
	}
}
